import React from "react";
import "../loginSignupPage.css";

import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Link, Outlet } from "react-router-dom";

import { ForgetPasswordProvider } from "../../../contexts/ForgetPasswordContext";

export default function FPStep1() {
  return (
    <div className="log_sign-background">
      <div className="log_sign-container">
        <Link to="..">
          <div className="close-button popup-mode-close">
            <FontAwesomeIcon icon={faArrowLeft} />
          </div>
        </Link>
        <div className="log_sign-popup forget-popup">
          <ForgetPasswordProvider>
            <Outlet />
          </ForgetPasswordProvider>
        </div>
      </div>
    </div>
  );
}
